import { PropertySettingModel } from '@modules/property-setting/property-setting-model';

const { fields } = PropertySettingModel;

export default [
  fields.id,
  fields.theme,
  fields.createdAt
];
